// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__fx5G-","additionalInfo":"AgreementModal_additionalInfo__39Khp"};